module.exports = __webpack_public_path__ + "bec6f391c20a3aaf78d457abbe0a017e.svg";